import { FormField } from '../../../types/form-builder.types';
import { cn } from '@shondalai/ui-commons';
import { GripVertical } from 'lucide-react';
import { useState } from 'react';

interface RankingFieldProps {
  field: FormField;
  value: string[];
  onChange: (value: string[]) => void;
}

export function RankingField({ field, value, onChange }: RankingFieldProps) {
  const config = field.config;
  const options = (config as any).options || [];
  const disabled = (config as any).disabled;

  // Initialize value with all options if not set
  const [rankedItems, setRankedItems] = useState(() => {
    if (value && value.length > 0) {
      return value.map(val => options.find((opt: any) => opt.value === val)).filter(Boolean);
    }
    return options;
  });

  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);

  const handleDragStart = (index: number) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (e: React.DragEvent, index: number) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === index) return;

    const items = [...rankedItems];
    const draggedItem = items[draggedIndex];
    items.splice(draggedIndex, 1);
    items.splice(index, 0, draggedItem);

    setRankedItems(items);
    setDraggedIndex(index);
    onChange(items.map((item: any) => item.value));
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  return (
    <div className="easyforms-ranking-field">
      <div className="space-y-2">
        {rankedItems.map((option: any, index: number) => (
          <div
            key={option.value}
            draggable={!disabled}
            onDragStart={() => handleDragStart(index)}
            onDragOver={(e) => handleDragOver(e, index)}
            onDragEnd={handleDragEnd}
            className={cn(
              "flex items-center gap-3 p-3 border rounded-lg bg-card cursor-move transition-all",
              draggedIndex === index && "opacity-50",
              disabled && "opacity-50 cursor-not-allowed"
            )}
          >
            <GripVertical className="h-5 w-5 text-muted-foreground flex-shrink-0" />
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm font-semibold">
              {index + 1}
            </span>
            <span className="flex-1">{option.label}</span>
          </div>
        ))}
      </div>
      {config.helpText && (
        <p className="text-xs text-muted-foreground mt-2">{config.helpText}</p>
      )}
    </div>
  );
}

